import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { BudgetItem } from "src/app/shared/models/partida-presupuesto";

@Injectable({
    providedIn: 'root'
})
export class CachePartidasService {
    private cache = new Map<string, BudgetItem>();
    public cache$ = new BehaviorSubject<BudgetItem[]>([]);

    private cacheBudget = new Map<string, any>();
    public cacheBudget$ = new BehaviorSubject<any[]>([]);

    constructor() { }

    //Guardar un objeto
    saveOnBudget(id: string, objeto: any): void {
        if (!this.cacheBudget.has(id)) {
            this.cacheBudget.set(id, objeto);
            let objetosActualizados = [...this.cacheBudget.values()];
            this.cacheBudget$.next(objetosActualizados);
            //return of(objeto);
        }
    }

    //Obtener un objeto por ID
    getOnBudgetById(id: string): Observable<any> {
        let objeto = this.cacheBudget.get(id);
        return of(objeto);
    }

    //Modificar un objeto
    modifyOnBudget(id: string, objeto: any): void {
        this.cacheBudget.set(id, objeto);
        let objetosActualizados = [...this.cacheBudget.values()];
        this.cacheBudget$.next(objetosActualizados);
        //return of(objeto);
    }

    validateIdOnBudget(id: string): boolean {
        return this.cacheBudget.has(id);
    }

    //Obtener todos los objetos
    getAll(): Observable<BudgetItem[]> {
        return this.cache$.asObservable();
    }

    validateId(id: string): boolean {
        return this.cache.has(id);
    }

    //Guardar un objeto
    save(id: string, objeto: BudgetItem): void {
        if (!this.cache.has(id)) {
            this.cache.set(id, objeto);
            let objetosActualizados = [...this.cache.values()];
            this.cache$.next(objetosActualizados);
            //return of(objeto);
        }
    }

    //Eliminar un objeto
    delete(id: string): void {
        this.cache.delete(id);
        let objetosActualizados = [...this.cache.values()];
        this.cache$.next(objetosActualizados);
        //return of(objetoEliminado);
    }

    //Modificar un objeto
    modify(id: string, objeto: BudgetItem): void {
        this.cache.set(id, objeto);
        let objetosActualizados = [...this.cache.values()];
        this.cache$.next(objetosActualizados);
        //return of(objeto);
    }

    //Limpiar cache
    clear(): void {
        this.cache.clear();
        this.cache$.next([]);
        this.cacheBudget.clear();
        this.cacheBudget$.next([]);
    }
}